// extracted by mini-css-extract-plugin
export default {"chip":"LessonChip_chip__CDVKo","dragging":"LessonChip_dragging__wsl-x","title":"LessonChip_title__ye1L8","grade":"LessonChip_grade__pIPbW"};